import { render, staticRenderFns } from "./PlayerBar.vue?vue&type=template&id=1af1e034&scoped=true&"
import script from "./PlayerBar.vue?vue&type=script&lang=js&"
export * from "./PlayerBar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBar.vue?vue&type=style&index=0&id=1af1e034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af1e034",
  null
  
)

export default component.exports